import { render, staticRenderFns } from "./createCompanyPrice.vue?vue&type=template&id=a642c768"
import script from "./createCompanyPrice.vue?vue&type=script&lang=js"
export * from "./createCompanyPrice.vue?vue&type=script&lang=js"
import style0 from "./createCompanyPrice.vue?vue&type=style&index=0&id=a642c768&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports